import { useEffect, useState } from 'react'
import JsonTableEditor from "../../atoms/jsonFormEditor/JsonTableEditor";
import UpdateCancel from "../../atoms/buttons/UpdateCancel";
import { Grid } from '@material-ui/core';
import { findEditorSchemaOfSelectedTemplate } from "../../../config/routing_rule.mjs";
import { constructIds } from '../../../config/common'
import './style.css';

const options = {
    form_name_root: "routing_rule_form",
    show_errors: "never",
    disable_collapse: true,
    disable_array_add: true,
    disable_array_delete: true,
    disable_array_reorder: true,
    disable_properties: true,
    no_additional_properties: false,
    keep_oneof_values: false
}


export default function RoutingRuleForm({ allEvents, rrdefs, defaultObj, selectedDelegate, clusterlets, selectedRrdef, onSave, onClose, rrdefSchema, loading, autoRrdefName, action, hideCancel }) {
    const [schema, setSchema] = useState(null);
    const [schemaValues, setSchemaValues] = useState({});
    const [isUpdating, setIsUpdating] = useState(false);
    const [formData, setFormData] = useState({});
    const [templates, setTemplates] = useState([]);

    const [name, setName] = useState(autoRrdefName ? autoRrdefName : "");
    const [selectedTemplate, setSelectedTemplate] = useState(undefined);
    const [selectedTemplateSchema, setSelectedTemplateSchema] = useState([]);


    useEffect(() => {
        loadRoutingRuleInfo();
    }, []);

    const loadRoutingRuleInfo = () => {
        try {
       
            let templatesArray = [{ title: "Select template", value: "select" }];
            const filteredRrdefSchema = rrdefSchema?.filter(template => {
                if (!defaultObj.dir ||defaultObj.dir === "") {
                    return true;
                }

                const dirObj = template?.find(obj => obj.name === "dir");
                return dirObj && dirObj.args.default === defaultObj.dir;
            });
            
            filteredRrdefSchema?.forEach(item => {
                const template = item?.find(obj => obj?.name === 'templatename');
                if (template?.args.default) {
                    templatesArray.push({ title: template?.args?.desc, value: template?.args?.default });
                }
            });

            setTemplates(templatesArray);
            if (selectedRrdef?.attributes && filteredRrdefSchema?.length > 0) {
                let templateSchemaSelected = filteredRrdefSchema?.find(item => 
                    item
                        .filter(obj => obj.args.default !== undefined && obj.name !== "templatename")
                        .every(obj => selectedRrdef.attributes[obj.name] === obj.args.default)
                );
                templateSchemaSelected = templateSchemaSelected ? templateSchemaSelected : filteredRrdefSchema[0];
                if (templateSchemaSelected) {
                    setSelectedTemplateSchema(templateSchemaSelected);
                    const templateSelected = templateSchemaSelected.find(obj => obj.name === "templatename")?.args?.default;
                    setSelectedTemplate(templateSelected);
                    setName(selectedRrdef.name);
                    const filteredTemplateSchema = templateSchemaSelected.filter(item => item.name !== "name" && item.name !== "templatename" && item.args.visibility !== "false");
                
                    // const dir = templateSchemaSelected.find(item => item.name === "dir")?.args?.default;
                    const routingRuleFormSchema = findEditorSchemaOfSelectedTemplate({ filteredTemplateSchema, events: allEvents, clusterlets, selectedDelegate, tag: defaultObj.tag });
                    setSchema(routingRuleFormSchema);
                
                    const rrdefFormData = findRoutingRuleFormData(filteredTemplateSchema, defaultObj, selectedRrdef);
                    setSchemaValues(rrdefFormData);
                }
            }
            

        } catch (error) {
            console.error(`Loading routing rule info failed. ${error}`);
            setSchemaValues({});
            setSchema(null);
               
        }
    }   


    const findRoutingRuleFormData = (routingRuleFormSchema, defaultObj, selectedRrdef) => {
        try {
            if(routingRuleFormSchema === undefined || routingRuleFormSchema === null){
                console.error(`Finding routing rule form data failed. Value of 'routingRuleFormSchema' is undefined/null `);
                return null;
            }
        
        rrdefSchema = JSON.parse(JSON.stringify(routingRuleFormSchema));
        let data = {};
        if (selectedRrdef) {
            routingRuleFormSchema?.forEach(item => {
                if (item.children?.length > 0) {
                    data[item.name] = selectedRrdef.attributes[item.name] ? selectedRrdef.attributes[item.name] : "select";
                } else if (item.name === "ttype" || item.name === "tcmd") {
                    data[item.name] = selectedRrdef.attributes[item.name] ? selectedRrdef.attributes[item.name] : "select";
                } else {
                    data[item.name] = selectedRrdef.attributes[item.name] ? selectedRrdef.attributes[item.name] : "";
                }
            });
        } else {

            routingRuleFormSchema?.forEach(item => {
                if (item.children?.length > 0) {
                    data[item.name] = item.args?.default ? item.args?.default : "select";
                } else if (item.name === "ttype" || item.name === "tcmd") {
                    data[item.name] = defaultObj[item.name] ? defaultObj[item.name] : "select";
                } else {
                    data[item.name] = item.args?.default ? item.args?.default : "";
                }
            });

        }
        return data;

        } catch (error) {
            console.error(`Finding routing rule form data failed. ${error}`)    
        }   
    }



    const onChangeJsonEditor = (data) => {
        setFormData(data);
        customizeRoutingRuleForm();
    }

    const customizeRoutingRuleForm = () => {
        try {
            
        
        if (defaultObj.tag === 'event') {
            const dirElement = document.getElementById('routing_rule_form[dir]switcher');
            if (dirElement) dirElement.disabled = true;

            const ttypeElement = document.getElementById('routing_rule_form[dir][ttype]switcher');
            if (ttypeElement) ttypeElement.disabled = true;
        }
        const rrdefForm = document.getElementById("routingRuleForm");
        if(rrdefForm) {
            const fieldsRequired = rrdefForm.querySelectorAll('label.required');
            if (fieldsRequired.length > 0) {
            fieldsRequired.forEach(labelElement => {
                const containsSpan = labelElement.querySelector('span') !== null;
                if (!containsSpan) {
                const asterisk = document.createElement('span');
                asterisk.textContent = ' *';
                asterisk.style = 'color: red;';
                labelElement.appendChild(asterisk);
                }
            });
        }
    }


        } catch (error) {
            console.error(`Customising routing rule form failed. ${error}`);
        }
    }

    const validation = (schema, value, path) => {
        var errors = [];
        return errors;
    };

    const clearErrors = () => {
        try {
            
        const errorDivs = document.querySelectorAll('.validation-error');
        for (let i = 0; i < errorDivs.length; i++) {
            errorDivs[i].remove();
        }


        } catch (error) {
            console.error(`Clearing validation errors failed. ${error}`);
        }
    };

    const validateRoutingRuleForm = (data) => {
        try {
            
        
        let requiredProperties = [];
        let errors = [];
        selectedTemplateSchema?.forEach(item => {
            if (item.args?.optional === undefined || item.args?.optional === false) {
                requiredProperties.push(item);
            }
        });
        requiredProperties.forEach(item => {
            if (data[item.name] === "" || ((item.children || item.name === "ttype" || item.name === "tcmd") && data[item.name] === "select")) {
                errors.push({
                    key: `[${item.name}]`,
                    message: `${item.args.desc ? item.args.desc : item.name} is required`
                });
            }
        })
        return errors;

        } catch (error) {
            console.error(`Validating routing rule form failed. ${error}`);
            return [];
        }
    }

    const isInvalidValue = (value) => {
        if (value === null || value === undefined) return true;
    
        if (typeof value === "string") return value.trim() === "" || value === "select";
    
        if (Array.isArray(value)) {
            return value.every(isInvalidValue);
        }
    
        if (typeof value === "object") {
            return Object.values(value).every(isInvalidValue);
        }
    
        return false;
    };


    const onSubmit = () => {
        try {
            
    
        setIsUpdating(true);
        clearErrors();
        const validationErrors = validateRoutingRuleForm(formData);
        if (name === "") {
            const inputField = document.getElementById(`name`);
            if (inputField) {
                inputField.insertAdjacentHTML('afterend', `<p id="validation-error-name" class="text text-danger validation-error" >Name is required</p>`);
                validationErrors.push({key: "name", message: "Name is required"});
            }
        }

        if (selectedTemplate === "select" || selectedTemplate === undefined) {
            const inputField = document.getElementById(`template`);
            if (inputField) {
                inputField.insertAdjacentHTML('afterend', `<p id="validation-error-template" class="text text-danger validation-error" >Template is required</p>`);
            }
            validationErrors.push({key: "template", message: "Template is required"});
        }
       
        if (validationErrors.length > 0) {
            validationErrors.forEach(item => {
                const inputField = document.getElementById(`routing_rule_form${item.key}`);
                if (inputField) {
                    inputField.insertAdjacentHTML('afterend', `<p id="validation-error-${item.key}" class="text text-danger validation-error" >${item.message}</p>`);
                }
            });
            setIsUpdating(false);
            return;
        }
        let attributes = {};
        if (formData) {
            Object.keys(formData).filter(item => !isInvalidValue(formData[item])).forEach(item => {
                attributes[item] = formData[item];
            });
        }
        
        const newRrdef = {
            type: constructIds.find(x => x.type === 'rrdef').id,
            name: name,
            attributes: {
                ...attributes,
                delegate: selectedDelegate._id,
            }
        }

        onSave(newRrdef).then(response => {
            if (response.status === false && response.errors !== undefined && response.errors.length > 0) {
                const inputField = document.getElementById(`name`);
                if (inputField) {
                    inputField.insertAdjacentHTML('afterend', `<p id="validation-error-name" class="text text-danger validation-error" >${response.errors[0].message}</p>`);
                }
            }
            setIsUpdating(false);
        });

        } catch (error) {
            console.error(`Routing rule form sumbission failed. ${error}`);
        }

    }

    const handleNameChange = (e) => {
        setName(e.target.value);
    };

    const handleTemplateChange = (event) => {
        try {
            
        
        clearErrors();
        setSelectedTemplate(event.target.value);
        const templateSchemaSelected = rrdefSchema.find(array => array.some(obj => obj.name === "templatename" && obj.args?.default === event.target.value));
        setSelectedTemplateSchema(templateSchemaSelected);
        if (templateSchemaSelected) {
            const filteredTemplateSchema = templateSchemaSelected.filter(item => item.name !== "name" && item.name !== "templatename" && item.args.visibility !== "false");
           
            const dir = templateSchemaSelected.find(item => item.name === "dir")?.args?.default;
            const routingRuleFormSchema = findEditorSchemaOfSelectedTemplate({ filteredTemplateSchema, events: allEvents, clusterlets, selectedDelegate, tag: defaultObj.tag });
            if(routingRuleFormSchema){
                setSchema(routingRuleFormSchema);
    
                const rrdefFormData = {};
                filteredTemplateSchema?.forEach(item => {
                    if (item.children?.length > 0) {
                        rrdefFormData[item.name] = item.args?.default ? item.args?.default : "select";
                    } else if (item.name === "ttype" || item.name === "tcmd") {
                        rrdefFormData[item.name] = defaultObj[item.name] ? defaultObj[item.name] : "select";
                    } else {
                        rrdefFormData[item.name] = item.args?.default ? item.args?.default : "";
                    }
                });
                
                setSchemaValues(rrdefFormData);
            }else{
                setSchema(null);
                setSchemaValues({});
            }
        } else {
            setSchema(null);
            setSchemaValues({});
        }

        } catch (error) {
            console.error(`Handling template change in routing rule failed. ${error}`);
            setSchema(null);
            setSchemaValues({});
        }
    }


    return (

        <>
            <Grid item xs={12}>
                <label for="name" class="input-label">Name<span style={{ color: "red" }}> *</span></label>
                <input id="name" value={name} class="input-box" onChange={handleNameChange} />

            </Grid>

            <Grid item xs={12}>
                <label for="template" class="input-label" id="template-label">Template<span style={{ color: "red" }}> *</span></label>
                <select id="template" value={selectedTemplate} name="options" onChange={handleTemplateChange} class="input-box">
                    {templates.map((option) => (
                        <option value={option.value}>{option.title}</option>

                    ))}
                </select>
            </Grid>
            {
                schema &&
                <JsonTableEditor options={options} schema={schema} schemaValues={schemaValues} validation={validation} onChangeJsonEditor={onChangeJsonEditor} editorId={"routingRuleForm"} />
            }

            <Grid item xs={12} style={loading ? { display: "flex", justifyContent: "flex-end", marginBottom: 20, marginTop: "30vh" } : { display: "flex", justifyContent: "flex-end", marginTop: 30 }}>
                <UpdateCancel forceCancel hideCancel={hideCancel} updateDisable={isUpdating || loading} content={(action === "create" && !isUpdating) ? "Create" : (action === "create" && isUpdating) ? "Creating.." : isUpdating ? 'Updating..' : 'Update'} onUpdate={onSubmit} onCancel={onClose} typesNotIn={['transaction', 'view', 'simulation']} />
            </Grid>
        </>



    )



}